import styled from 'styled-components'

export const Container = styled.div`
  background: #fff;
`

export const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #262626;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }

  @media (max-width: 1400px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 12px;
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 10px;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const DayCardWrapper = styled.div<{ $isToday?: boolean }>`
  min-height: 450px;
  width: 100%;

  .ant-card {
    transition: all 0.3s;
    height: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    ${props =>
      props.$isToday &&
      `
      border: 2px solid #1890ff !important;
      box-shadow: 0 4px 20px rgba(24, 144, 255, 0.3);
    `}
  }

  .ant-card-head {
    padding: 14px 18px;
    min-height: auto;
    background: linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%);

    ${props =>
      props.$isToday &&
      `
      background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
    `}
  }

  .ant-card-body {
    padding: 14px;
  }

  @media (max-width: 1200px) {
    min-height: 420px;
  }

  @media (max-width: 992px) {
    min-height: 400px;
  }

  @media (max-width: 768px) {
    min-height: 380px;

    .ant-card-head {
      padding: 12px 14px;
    }

    .ant-card-body {
      padding: 12px;
    }
  }

  @media (max-width: 576px) {
    min-height: 350px;

    .ant-card-head {
      padding: 10px 12px;
    }

    .ant-card-body {
      padding: 10px;
    }
  }
`

export const DayHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 0;
`

export const DayName = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 11px;
  }

  @media (max-width: 576px) {
    font-size: 10px;
  }
`

export const DayNumber = styled.div<{ $isToday?: boolean }>`
  font-size: 24px;
  font-weight: 700;
  color: ${props => (props.$isToday ? '#1890ff' : '#262626')};
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 576px) {
    font-size: 18px;
  }
`

export const DayContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 13px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;

    &:hover {
      background: #bfbfbf;
    }
  }

  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;

  @media (max-width: 1200px) {
    max-height: 500px;
  }

  @media (max-width: 992px) {
    max-height: 450px;
  }

  @media (max-width: 768px) {
    max-height: 400px;
    font-size: 12px;
    gap: 8px;
  }

  @media (max-width: 576px) {
    max-height: 350px;
    font-size: 11px;
  }
`

export const NoTasks = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 350px;
  color: #bfbfbf;
  font-size: 14px;
  font-weight: 500;

  @media (max-width: 1200px) {
    min-height: 320px;
  }

  @media (max-width: 992px) {
    min-height: 300px;
  }

  @media (max-width: 768px) {
    min-height: 280px;
    font-size: 13px;
  }

  @media (max-width: 576px) {
    min-height: 250px;
    font-size: 12px;
  }
`
